import { PalConstantHelper } from "@palamar/fe-library";

export const [chatMessageTypes, chatMessageTypeOptions, chatMessageTypeMap] = PalConstantHelper.typify({
  PUBLIC: "Public",
  PRIVATE: "Private",
});
